// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";
import { setURLParams } from "src/utils/url-query";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getTasks: "/task_manager/query_by_page",
    queryById: "/task_manager/query_by_ids"
};

// ----------------------------------------------------------------------

const getPopoverTasks = (request) => axios.get(`${ API_ENDPOINTS.getTasks }`, {
    params: {
        ...request
    }
});

const getTaskById = (ids) => axios.get(`${ API_ENDPOINTS.queryById }`, {
    params: {
        task_ids: ids.join(",")
    }
});

// ----------------------------------------------------------------------

const {
    useGetTaskListQuery
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getTaskList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "TaskList" ],
            query: (request) => `${ API_ENDPOINTS.getTasks }${ setURLParams(request) }`,
            transformResponse: ({ data }, meta, arg) => data
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    useGetTaskListQuery,
    //
    getPopoverTasks as getPopoverTasksAPI,
    getTaskById as getTaskByIdAPI
};
